import { render, staticRenderFns } from "./UploadNavBar.vue?vue&type=template&id=56ba7212&"
import script from "./UploadNavBar.vue?vue&type=script&lang=js&"
export * from "./UploadNavBar.vue?vue&type=script&lang=js&"
import style0 from "./UploadNavBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports